
export const interests =  [
  "Full-Time Jobs",
  "Contingent Jobs",

]
